/**
 * useWidgetSDK — public hook charts and summary surfaces use to open
 * widgets.
 *
 * Re-exported from `src/widgets/index.js`. Treat this file as part of
 * the public contract; changing the return shape is a v1 SDK change.
 */

import { useMemo } from 'react';

import useWidgetRouterStore from '../internals/widgetRouterStore';

export function useWidgetSDK() {
  const activeWidget = useWidgetRouterStore((s) => s.active);
  const openWidget = useWidgetRouterStore((s) => s.openWidget);
  const closeWidget = useWidgetRouterStore((s) => s.closeWidget);

  return useMemo(
    () => ({ openWidget, closeWidget, activeWidget }),
    [openWidget, closeWidget, activeWidget],
  );
}

export default useWidgetSDK;
